var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { class: _vm.ulClass },
    _vm._l(_vm.data, function (item) {
      return _c(
        "li",
        { key: _vm.getKey(item), class: _vm.liClass },
        [
          _vm._t(
            "default",
            function () {
              return [_vm._v("\n          " + _vm._s(item) + "\n      ")]
            },
            { item: item }
          ),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }